(function () {
  const desktopWidth = 1080;
  const mobileMenuToggle = document.querySelector(".menu-toggle");
  const menu = document.querySelector(".header-menu-wrapper");
  const body = document.querySelector("body");
  const menuItems = document.querySelectorAll(
    ".primary-nav__menu li.primary-nav__menu-item--has-children"
  );
  let timer1, timer2, isDesktop;

  document.addEventListener("DOMContentLoaded", function () {
    checkIsDesktop();
  });

  window.addEventListener("resize", function () {
    clearTimeout(timer1);
    timer1 = setTimeout(checkIsDesktop, 250);
  });

  document.addEventListener("keyup", function (event) {
    if (event.keyCode === 27) {
      if (isDesktop) {
        closeAllSubNav();
      } else {
        hideMobileMenu();
      }
    }
  });

  document
    .querySelector(".primary-nav__menu--level-1")
    .lastElementChild.addEventListener("keydown", function (event) {
      if (9 == event.keyCode && !event.shiftKey && !isDesktop) {
        event.preventDefault();
        mobileMenuToggle.focus();
      }
    });

  mobileMenuToggle.addEventListener("click", function (event) {
    if (body.classList.contains("showing-mobile-menu")) {
      hideMobileMenu();
    } else {
      showMobileMenu();
    }
    event.preventDefault();
  });

  function showMobileMenu() {
    mobileMenuToggle.classList.add("active");
    mobileMenuToggle.setAttribute("aria-expanded", "true");
    menu.classList.add("visible");
    body.classList.add("showing-mobile-menu");
  }

  function hideMobileMenu() {
    mobileMenuToggle.classList.remove("active");
    mobileMenuToggle.setAttribute("aria-expanded", "false");
    menu.classList.remove("visible");
    body.classList.remove("showing-mobile-menu");
  }

  function checkIsDesktop() {
    isDesktop = false;

    if (document.documentElement.clientWidth >= desktopWidth) {
      isDesktop = true;
      hideMobileMenu();
    }
  }

  function closeAllSubNav() {
    document
      .querySelector(
        ".primary-nav__menu .primary-nav__menu-item--has-children.open .primary-nav__menu-link"
      )
      .setAttribute("aria-expanded", "false");
    document
      .querySelector(
        ".primary-nav__menu .primary-nav__menu-item--has-children.open button"
      )
      .setAttribute("aria-expanded", "false");
    document
      .querySelector(
        ".primary-nav__menu .primary-nav__menu-item--has-children.open"
      )
      .classList.remove("open");
  }

  Array.prototype.forEach.call(menuItems, function (el, i) {
    el.addEventListener("mouseover", function (event) {
      if (isDesktop) {
        this.classList.add("open");
        this.querySelector(".primary-nav__menu-link").setAttribute(
          "aria-expanded",
          "true"
        );
        this.querySelector("button").setAttribute("aria-expanded", "true");
      }
    });

    el.addEventListener("mouseout", function (event) {
      if (isDesktop) {
        closeAllSubNav();
      }
    });

    el.querySelector("button").addEventListener("click", function (event) {
      if (this.parentNode.classList.contains("open")) {
        this.parentNode.classList.remove("open");
        this.parentNode
          .querySelector(".primary-nav__menu-link")
          .setAttribute("aria-expanded", "false");
        this.parentNode
          .querySelector("button")
          .setAttribute("aria-expanded", "false");
      } else {
        this.parentNode.classList.add("open");
        this.parentNode
          .querySelector(".primary-nav__menu-link")
          .setAttribute("aria-expanded", "true");
        this.parentNode
          .querySelector("button")
          .setAttribute("aria-expanded", "true");
      }
      event.preventDefault();
    });

    var links = el.querySelectorAll("a");
    Array.prototype.forEach.call(links, function (el, i) {
      el.addEventListener("focus", function () {
        if (timer2) {
          clearTimeout(timer2);
          timer2 = null;
        }
      });
      el.addEventListener("blur", function (event) {
        timer2 = setTimeout(function () {
          var opennav = document.querySelector(
            ".primary-nav__menu .primary-nav__menu-item--has-children.open"
          );
          if (opennav) {
            opennav.classList.remove("open");
            opennav.querySelector("a").setAttribute("aria-expanded", "false");
            opennav
              .querySelector("button")
              .setAttribute("aria-expanded", "false");
          }
        }, 10);
      });
    });

    var subLinks = el.querySelectorAll(".menu-level-1");
    Array.prototype.forEach.call(subLinks, function (el, i) {
      el.lastElementChild.addEventListener("keydown", function (event) {
        if (9 == event.keyCode && !event.shiftKey) {
          event.preventDefault();
          this.parentNode.parentNode.parentNode.parentNode.parentNode
            .querySelector("button")
            .focus();
        }
      });
    });
  });
})();
